import { getHttpStatus } from '@evidentid/gateway-api-client';

/** Whether a gateway rejection is an auth failure, which belongs on the global persisting-error
 * screen that re-authenticates rather than in the page's own inline failure state.
 *
 * 🚨 THE STATUS IS NOT ENOUGH, AND FOR THESE STATUSES IT IS NEVER THERE. The gateway client
 * intercepts 401/403/404/440 in `statusErrorFactories` BEFORE the response body is read, and
 * rejects with an `XhrError` carrying a `reason` string. Only the statuses with no interceptor
 * reach `withHttpStatus`, so `getHttpStatus` answers null for exactly the four this would want it
 * for -- a `httpStatus === 401 || httpStatus === 403` test is dead code that never fires, and an
 * expired session shows "could not be loaded" instead of re-authenticating. `getRevertErrorMessage`
 * documents the same trap for the revert flow.
 *
 * The status is still consulted, so this keeps answering correctly if the interceptor list changes.
 */
export function isAuthFailure(error: unknown): boolean {
    const reason = (error as { reason?: unknown } | null)?.reason;
    if (reason === 'unauthorized' || reason === 'forbidden' || reason === 'session-expired') {
        return true;
    }
    const status = getHttpStatus(error);
    return status === 401 || status === 403 || status === 440;
}
